/* appLogos — single source of truth for every Raw Company sister-app logo.
   Owner asked: "use my actual app logos throughout — they're already on
   the live sites, you can pull them down without me re-sharing."
   We point at each app's `apple-touch-icon.png` (the high-res icon iOS
   uses when an app is added to the home screen — already designed and
   uploaded by the owner). If that 404s the <AppLogo /> renderer falls
   back to Google's favicon-fetcher so we still get *something* on screen
   while the owner uploads a touch icon. */

export const APP_LOGO_REGISTRY = {
  rawcompany:   { domain: "rawcompany.uk",          label: "Raw Company"        },
  snapdog:      { domain: "dogsnap.co.uk",          label: "SnapDog"            },
  clothing:     { domain: "rawcompanyclothing.uk",  label: "Raw Company Clothing" },
  rawmixes:     { domain: "rawmixes.co.uk",         label: "Raw Mixes"          },
  racing:       { domain: "rawcompanyracing.uk",    label: "Racing Form Guide"  },
  trader:       { domain: "rawcotrading.uk",        label: "Raw Co. Trading"    },
  capital:      { domain: "capital.com",            label: "Capital.com"        },
};

// Build the candidate URL list. We try in order and fall back as needed.
export function logoCandidates(brandKey) {
  const reg = APP_LOGO_REGISTRY[brandKey];
  if (!reg) return [];
  const d = reg.domain;
  return [
    `https://${d}/apple-touch-icon.png`,
    `https://${d}/apple-touch-icon-180x180.png`,
    `https://${d}/apple-touch-icon-precomposed.png`,
    `https://${d}/favicon.png`,
    // Google's universal favicon fetcher — always returns *something*
    `https://www.google.com/s2/favicons?domain=${d}&sz=128`,
  ];
}

// Resolve a brand key by NAME (case-insensitive). Lets non-tile callers
// (like NeuralinkBrain3D) pass "Raw Company" and still get the right key.
export function brandKeyFromName(name) {
  if (!name) return null;
  const n = name.toLowerCase().trim();
  if (n.includes("snap"))     return "snapdog";
  if (n.includes("cloth"))    return "clothing";
  if (n.includes("mix"))      return "rawmixes";
  if (n.includes("rac"))      return "racing";
  if (n.includes("trad"))     return "trader";
  if (n.includes("capital"))  return "capital";
  if (n.includes("raw company") || n === "raw" || n === "raw co") return "rawcompany";
  return null;
}
